export default __webpack_public_path__ + "static/media/icon-grimacingface.1dd77d26.svg";